import { CommonModule } from '@angular/common';
// This Module's Components
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SessionTimeOutComponent } from './session-time-out.component';

@NgModule({
  imports: [CommonModule, ModalModule.forRoot(), HttpClientModule],
  declarations: [SessionTimeOutComponent],
  exports: [SessionTimeOutComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SessionTimeOutModule {}
